import * as Sentry from '@sentry/react';
import { notification } from 'antd';

export class AppError extends Error {
    constructor(title, description) {
        super(title);
        this.name = 'AppError';
        this.title = title;
        this.description = description;
    }
}

export const handleError = (err, title, description) => {
    const isAppError = err instanceof AppError;
    Sentry.captureException(isAppError ? err : (err || new Error(title)));
    notification.error({
        message: isAppError ? err.title : title,
        description: isAppError ? err.description : description,
    });
};
